import { inject, injectable } from "inversify";
import { ICPLClientPortalMeetingTypesClient, IntSelectModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalMeetingTypesService {
  getMeetingTypeSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class ClientPortalMeetingTypesService implements IClientPortalMeetingTypesService {
  @inject(SERVICE_TYPES.CPLClientPortalMeetingTypesClient)
  cplClientPortalMeetingTypesClientClient!: ICPLClientPortalMeetingTypesClient;

  async getMeetingTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplClientPortalMeetingTypesClientClient.getMeetingTypeSelectModels();
  }
}
